module.exports = __webpack_public_path__ + "static/do-526509b9e85f4d3c8489a610701e7471.svg";